import axios from 'axios'
import initializers from '../../dependencies/initializers'
import _ping from '../../dependencies/_ping'
import { change } from 'redux-form';


function checkPing() {
	var start = new Date().getTime();
	const timeout = new Promise((resolve, reject) => {
		setTimeout(reject, 1000, "Request timed out");
	});
	const options = {
		url: "/astro-jobs"
	};
	const request = _ping(options);
	return Promise.race([timeout, request])
		.then(response => {
			console.log('ping success')
		})
		.catch(error => {
			let end = new Date().getTime();
			let time = end - start;
			let reason = "Timeout";
			console.log('timeout')
		});
}




export function docAttachmentSuccess(file_attachment) {
	return {
		type: 'DOCUMENT_ADD_FILE_ATTACHMENT_SUCCESS',
		file_attachment
	}
}

export function docAttachment(file_attachment) {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			resolve(dispatch(docAttachmentSuccess(file_attachment)))
		})
	}
}

export function send(company_id, file, extension, fileName, curr_index, end, start, size, new_file) {
	return (dispatch, getState) => {

		return new Promise((resolve, reject) => {


			const formData = new FormData();
			let file_size = size
			const CancelToken = axios.CancelToken
			const cancelTokenSource = CancelToken.source()
			let docAttachmentUpdated = getState().documentAttachment.get('file_attachment').toJS()
			//to cancel set up cancelTokenSource into reducer 
			//operat by cancelTokenSource.cancel()
			const end_point = initializers.api_host + `/companies/${company_id}/upload`;
			formData.append('dataFile', file)
			formData.append('extension', extension)
			formData.append('fileName', fileName)
			formData.append('identifier', docAttachmentUpdated[curr_index]['identifier'])
			formData.append('size', size)
			formData.append('end', end)
			formData.append('isNewFile', new_file)

			// curr_index itu adalah reducerIndexattachmentnya
			const startTime = new Date().getTime();

			docAttachmentUpdated[curr_index]['tokenCancel'] = cancelTokenSource;

			dispatch(dispatch(docAttachmentSuccess(docAttachmentUpdated)))

			return axios({
				url: end_point,
				method: "post",
				timeout: 200000,
				data: formData,
				cancelToken: cancelTokenSource.token,
				headers: {
					'Content-Type': 'application/json',
				},
			})
				.then((response) => {
					const { filepath } = response.data

					//check upload speed
					let endTime = new Date().getTime();
					let time = endTime - startTime;
					const uploadTime = time / 1000.0;
					const bitsLoaded = 1000024 * 8;
					var speedBps = (bitsLoaded / uploadTime).toFixed(2);
					var speedKbps = (speedBps / 1024).toFixed(2);
					var speedMbps = (speedKbps / 1024).toFixed(2);

					//estimation time 
					const file_size_inbps = file_size * 8
					const estimation_in_minutes = (file_size_inbps / speedBps) / 60

					let file_unit_value = 'MB'
					let percentage = Math.round((end / file_size) * 100)

					let docAttachmentUpdated = getState().documentAttachment.get('file_attachment').toJS()
					docAttachmentUpdated[curr_index]['startSize'] = start;
					docAttachmentUpdated[curr_index]['endSize'] = end;
					//progressFile show ex 1,8 MB of 3,5 MB
					docAttachmentUpdated[curr_index]['progressFile'] = Math.round(end / 1028576)
					docAttachmentUpdated[curr_index]['progress'] = percentage
					docAttachmentUpdated[curr_index]['progressUnit'] = 'MB'
					if (end == file_size) {
						docAttachmentUpdated[curr_index]['progress'] = 100
						docAttachmentUpdated[curr_index]['status'] = 'finish'
					}
					if (filepath) {
						docAttachmentUpdated[curr_index]['showBarProgress'] = 0
						docAttachmentUpdated[curr_index]['filepath'] = filepath
					} else if (speedMbps <= 0.3) {
						docAttachmentUpdated[curr_index]['status'] = 'paused'
						dispatch(dispatch(docAttachmentSuccess(docAttachmentUpdated)))
						reject('speed low')
					}
					dispatch(dispatch(docAttachmentSuccess(docAttachmentUpdated)))

					if (estimation_in_minutes > 5) {
						resolve('longupload')
					}
					if (curr_index == 0) {
						const { content } = response.data

						if (content.status == 200) {
							const { profile } = content.response.data

							dispatch(change('CompanyJobDetailByCode', 'fullname', profile.name.trim()));
							dispatch(change('CompanyJobDetailByCode', 'preferred_name', (profile.preferred || profile.name.trim())));
							dispatch(change('CompanyJobDetailByCode', 'email', profile.email.trim()));
							dispatch(change('CompanyJobDetailByCode', 'phone', profile.phone.trim()));
							dispatch(change('CompanyJobDetailByCode', 'location', profile.location || ''));
							dispatch(change('CompanyJobDetailByCode', 'cv_raw_content', content.response.data))
						}
					}
					resolve('ok')

				})
				.catch((error) => {
					if (error == 'canceled') {
						console.log('Request canceled', error.message)
					} else {
						console.log('masuk sini')
						let docAttachmentUpdated = getState().documentAttachment.get('file_attachment').toJS()

						docAttachmentUpdated[curr_index]['status'] = 'failed'
						dispatch(docAttachmentSuccess(docAttachmentUpdated))
						reject('time out')

					}

				})
		})


	}
}

export function docAttachmentUpload(company_id, file, curr_index, indexDocument, up_time = null) {
	return (dispatch, getState) => {
		//file size
		let file_size = file.size / 1028576  //in MB

		const CancelToken = axios.CancelToken
		const source = CancelToken.source()
		const end_point = initializers.api_host + `/companies/${company_id}/multi_document_save`;
		const formData = new FormData();
		if (indexDocument == 0) {
			formData.append('is_cv', 1)
		}
		formData.append('file', file)
		const upload_id = Math.floor(Math.random() * 100)
		let canceled = 0;
		let docAttachmentUpdated = getState().documentAttachment.get('file_attachment').toJS()
		docAttachmentUpdated[curr_index]['tokenCancel'] = source;
		dispatch(dispatch(docAttachmentSuccess(docAttachmentUpdated)))
		return axios({
			url: end_point,
			method: "post",
			timeout: 200000,
			data: formData,
			cancelToken: source.token,
			onUploadProgress: progressEvent => {
				checkPing()
				let file_unit_value = 'MB'
				const uploadPercentage = Math.round(
					(progressEvent.loaded * 100) / progressEvent.total
				);
				let size_uploaded = Math.round(uploadPercentage / 100 * file_size)

				let docAttachmentUpdated = getState().documentAttachment.get('file_attachment').toJS()

				if (docAttachmentUpdated[curr_index]) {
					if (up_time) {
						if (up_time != docAttachmentUpdated[curr_index]['lastModified']) {
							source.cancel('Operation canceled by the user.');
							canceled = 1
						}
					}

				} else {
					source.cancel('Operation canceled by the user.');
					canceled = 1
				}

				if (!canceled) {
					if (progressEvent.loaded != progressEvent.total) {
						docAttachmentUpdated[curr_index]['progress'] = uploadPercentage
						if (size_uploaded < 1) {
							size_uploaded = Math.round(uploadPercentage / 100 * (file.size / 1028))
							file_unit_value = 'KB'
						}

						docAttachmentUpdated[curr_index]['progressFile'] = size_uploaded
						docAttachmentUpdated[curr_index]['progressUnit'] = file_unit_value
					}

					dispatch(docAttachmentSuccess(docAttachmentUpdated))
				}


			},
		})
			.then((response) => {
				const { filepath } = response.data

				let docAttachmentUpdated = getState().documentAttachment.get('file_attachment').toJS()
				const publicJobDetail = getState().publicJobDetail.toJS();
				const translations = publicJobDetail.translation || [];

				if (indexDocument == 0) {
					const { content } = response.data

					if (content.status == 200) {
						const { profile, workExperiences = [] } = content.response.data
						const fullname = profile.name ? profile.name.trim() : ''
						const preferred_name = profile.preferred ? profile.preferred.trim() : ''
						const email = profile.email ? profile.email.trim() : ''
						const phone = profile.phone ? profile.phone.trim() : ''
						const linkedin_url = profile.url || ''

						// Map work experiences to the format expected by the form
						const formattedWorkExperiences = workExperiences.map(exp => ({
							company_name: exp.company || '',
							job_title: exp.jobTitle || '',
							start_date: exp.date ? exp.date.split('–')[0].trim() : '',
							end_date: exp.date ? exp.date.split('–')[1]?.trim() : '',
							job_description: (exp.descriptions || []).join('\n'),
							industry: '',  // These fields aren't in the API response
							job_family: '',
							job_level: ''
						}));

						dispatch(change('CompanyJobDetailByCode', 'fullname', fullname));
						dispatch(change('CompanyJobDetailByCode', 'preferred_name', preferred_name));
						dispatch(change('CompanyJobDetailByCode', 'email', email));
						dispatch(change('CompanyJobDetailByCode', 'email2', email));
						dispatch(change('CompanyJobDetailByCode', 'phone', phone));
						dispatch(change('CompanyJobDetailByCode', 'location', profile.location || ''));
						dispatch(change('CompanyJobDetailByCode', 'linkedin_url', linkedin_url));
						dispatch(change('CompanyJobDetailByCode', 'employment_history', formattedWorkExperiences));
						dispatch(change('CompanyJobDetailByCode', 'cv_raw_content', content.response.data))
					} else {
						const { message } = content.response
						if (message) {
							const errMessage = translations['LABEL_CV_UNRESOLVED']
							const status = "failed"
							docAttachmentUpdated[curr_index]['errorMessage'] = errMessage
							docAttachmentUpdated[curr_index]['status'] = status
						}

						dispatch(docAttachmentSuccess(docAttachmentUpdated))
						dispatch(change('CompanyJobDetailByCode', 'cv_raw_content', content.response.data))
						return;
					}
				}

				docAttachmentUpdated[curr_index]['progressFile'] = docAttachmentUpdated[curr_index]['sizeFile']
				docAttachmentUpdated[curr_index]['progressUnit'] = docAttachmentUpdated[curr_index]['sizeUnit']
				docAttachmentUpdated[curr_index]['progress'] = 100
				docAttachmentUpdated[curr_index]['status'] = 'finish'
				docAttachmentUpdated[curr_index]['filepath'] = filepath
				dispatch(docAttachmentSuccess(docAttachmentUpdated))

				setTimeout(() => {
					docAttachmentUpdated = getState().documentAttachment.get('file_attachment').toJS()
					if (docAttachmentUpdated[curr_index]) {
						docAttachmentUpdated[curr_index]['showBarProgress'] = 0
					}
					dispatch(docAttachmentSuccess(docAttachmentUpdated))
				}, 3000);
			})
			.catch((error) => {
				console.log(error, 'error')
				if (error == 'canceled') {
					console.log('Request canceled', error.message)
				} else {
					let docAttachmentUpdated = getState().documentAttachment.get('file_attachment').toJS()

					docAttachmentUpdated[curr_index]['status'] = 'failed'
					dispatch(docAttachmentSuccess(docAttachmentUpdated))
				}
			})
	}
}


export function docAttachmentCV(company_id, file, curr_index, indexDocument, up_time = null) {
	return (dispatch, getState) => {
		//file size
		let file_size = file.size / 1028576  //in MB

		const CancelToken = axios.CancelToken
		const source = CancelToken.source()
		const end_point = initializers.api_host + `/companies/${company_id}/store_and_extract_document`;
		const formData = new FormData();
		if (indexDocument == 0) {
			formData.append('is_cv', 1)
		}
		formData.append('file', file)
		const upload_id = Math.floor(Math.random() * 100)
		let canceled = 0;
		let docAttachmentUpdated = getState().documentAttachment.get('file_attachment').toJS()
		docAttachmentUpdated[curr_index]['tokenCancel'] = source;
		dispatch(dispatch(docAttachmentSuccess(docAttachmentUpdated)))
		return axios({
			url: end_point,
			method: "post",
			timeout: 200000,
			data: formData,
			cancelToken: source.token,
			onUploadProgress: progressEvent => {
				checkPing()
				let file_unit_value = 'MB'
				const uploadPercentage = Math.round(
					(progressEvent.loaded * 100) / progressEvent.total
				);
				let size_uploaded = Math.round(uploadPercentage / 100 * file_size)

				let docAttachmentUpdated = getState().documentAttachment.get('file_attachment').toJS()

				if (docAttachmentUpdated[curr_index]) {
					if (up_time) {
						if (up_time != docAttachmentUpdated[curr_index]['lastModified']) {
							source.cancel('Operation canceled by the user.');
							canceled = 1
						}
					}

				} else {
					source.cancel('Operation canceled by the user.');
					canceled = 1
				}

				if (!canceled) {
					if (progressEvent.loaded != progressEvent.total) {
						docAttachmentUpdated[curr_index]['progress'] = uploadPercentage
						if (size_uploaded < 1) {
							size_uploaded = Math.round(uploadPercentage / 100 * (file.size / 1028))
							file_unit_value = 'KB'
						}

						docAttachmentUpdated[curr_index]['progressFile'] = size_uploaded
						docAttachmentUpdated[curr_index]['progressUnit'] = file_unit_value
					}

					dispatch(docAttachmentSuccess(docAttachmentUpdated))
				}


			},
		})
			.then((response) => {
				const { filepath } = response.data

				let docAttachmentUpdated = getState().documentAttachment.get('file_attachment').toJS()
				const publicJobDetail = getState().publicJobDetail.toJS();
				const translations = publicJobDetail.translation || [];

				if (indexDocument == 0) {
					const { content } = response.data

					if (content.status == 200) {
						// content.version === 'v2' means Gemini succeeded (rich structured data).
						// Otherwise the fallback parser (cv.astrnt.co) was used (simpler flat data).
						const isGemini = content.version === 'v2'

						let fullname, preferred_name, email, phone, address, location,
							date_of_birth, nationality, linkedin_url,
							formattedEmploymentHistory, formattedEducationBackground,
							soft_skills, hard_skills, languages, certifications, formattedKeyAchievements

						if (isGemini) {
							// --- Gemini v2 format: content.profile.contact_info ---
							const { profile } = content
							const {
								contact_info,
								employment_history = [],
								education_background = [],
								skills_certifications = {},
								key_achievements = []
							} = profile

							fullname       = contact_info.fullname ? contact_info.fullname.trim() : ''
							preferred_name = contact_info.preferred_name ? contact_info.preferred_name.trim() : ''
							email          = contact_info.email ? contact_info.email.trim() : ''
							phone          = contact_info.phone_number ? contact_info.phone_number.trim() : ''
							address        = contact_info.address || ''
							location       = contact_info.location || ''
							date_of_birth  = contact_info.date_of_birth || ''
							nationality    = contact_info.nationality || ''
							linkedin_url   = contact_info.profile?.linkedin || ''

							formattedEmploymentHistory = employment_history.map(exp => {
								let formatted_start_date = exp.start_date || ''
								if (exp.start_date && exp.start_date.match(/^\d{4}-\d{2}-\d{2}$/)) {
									formatted_start_date = exp.start_date.substring(0, 7)
								}
								let formatted_end_date = ''
								let is_current_job = false
								if (exp.end_date) {
									const endLower = exp.end_date.toLowerCase().trim()
									if (['present','now','current','ongoing','till now','to present','currently'].includes(endLower)) {
										is_current_job = true
									} else {
										formatted_end_date = exp.end_date.match(/^\d{4}-\d{2}-\d{2}$/)
											? exp.end_date.substring(0, 7)
											: exp.end_date
									}
								}
								return {
									company_name: exp.company_name || '-',
									job_title: exp.job_title || '',
									job_family: exp.job_family || '',
									job_level: exp.job_level || '',
									start_date: formatted_start_date,
									end_date: formatted_end_date,
									is_current_job: is_current_job,
									job_description: exp.job_description || '',
									industry: ''
								}
							})

							formattedEducationBackground = education_background.map(edu => {
								let gpa_value = ''
								if (edu.gpa) {
									const s = edu.gpa.toString().trim()
									const m = s.match(/^(\d+\.?\d*)/)
									gpa_value = m ? m[1] : s.split(/[ /\\]/)[0]
								}
								let formatted_graduation = edu.graduation_date || ''
								if (edu.graduation_date && edu.graduation_date.toLowerCase() === 'present') {
									formatted_graduation = ''
								} else if (edu.graduation_date && edu.graduation_date.match(/^\d{4}-\d{2}-\d{2}$/)) {
									formatted_graduation = edu.graduation_date.substring(0, 7)
								}
								return {
									institutional_name: edu.institutional_name || '-',
									field_of_study: edu.field_of_study || '',
									degree_obtained: edu.degree_obtained || '',
									date_attended: edu.date_attended
										? (edu.date_attended.match(/^\d{4}-\d{2}-\d{2}$/) ? edu.date_attended.substring(0, 7) : edu.date_attended)
										: '',
									graduation_date: formatted_graduation,
									is_currently_studying: edu.graduation_date?.toLowerCase() === 'present',
									gpa_score: gpa_value
								}
							})

							soft_skills           = skills_certifications.soft_skills || []
							hard_skills           = skills_certifications.hard_skills || []
							languages             = skills_certifications.languages || []
							certifications        = skills_certifications.certifications || []
							formattedKeyAchievements = key_achievements.map(a => {
								let d = a.date || ''
								if (d.match(/^\d{4}-\d{2}-\d{2}$/)) d = d.substring(0, 7)
								return { achievement: a.achievement || '-', date: d }
							})

						} else {
							// --- Fallback format: content.response.data ---
							const { profile, workExperiences = [], educations = [], skills = {} } = content.response.data

							fullname       = profile.name ? profile.name.trim() : ''
							preferred_name = profile.preferred ? profile.preferred.trim() : ''
							email          = profile.email ? profile.email.trim() : ''
							phone          = profile.phone ? profile.phone.trim() : ''
							address        = ''
							location       = profile.location || ''
							date_of_birth  = ''
							nationality    = ''
							linkedin_url   = profile.url || ''

							// Dates arrive as "Apr 2019 – Present" (em-dash separated)
							formattedEmploymentHistory = workExperiences.map(exp => {
								const parts = exp.date ? exp.date.split('–') : []
								const rawStart = parts[0] ? parts[0].trim() : ''
								const rawEnd   = parts[1] ? parts[1].trim() : ''
								const endLower = rawEnd.toLowerCase()
								const is_current_job = ['present','now','current','ongoing','till now','to present','currently'].includes(endLower)
								return {
									company_name: exp.company || '-',
									job_title: exp.jobTitle || '',
									job_family: '',
									job_level: '',
									start_date: rawStart,
									end_date: is_current_job ? '' : rawEnd,
									is_current_job: is_current_job,
									job_description: (exp.descriptions || []).join('\n'),
									industry: ''
								}
							})

							formattedEducationBackground = educations.map(edu => {
								let gpa_value = ''
								if (edu.gpa) {
									const s = edu.gpa.toString().trim()
									const m = s.match(/^(\d+\.?\d*)/)
									gpa_value = m ? m[1] : s.split(/[ /]/)[0]
								}
								return {
									institutional_name: edu.school || '-',
									field_of_study: edu.degree || '',
									degree_obtained: edu.degree || '',
									date_attended: '',
									graduation_date: edu.date || '',
									is_currently_studying: false,
									gpa_score: gpa_value
								}
							})

							hard_skills           = skills.descriptions || []
							soft_skills           = []
							languages             = []
							certifications        = []
							formattedKeyAchievements = []
						}

						// Dispatch form field updates
						dispatch(change('CompanyJobDetailByCode', 'fullname', fullname));
						dispatch(change('CompanyJobDetailByCode', 'preferred_name', preferred_name));
						dispatch(change('CompanyJobDetailByCode', 'email', email));
						dispatch(change('CompanyJobDetailByCode', 'email2', email));
						dispatch(change('CompanyJobDetailByCode', 'phone', phone));
						dispatch(change('CompanyJobDetailByCode', 'address', address));
						dispatch(change('CompanyJobDetailByCode', 'location', location));
						dispatch(change('CompanyJobDetailByCode', 'date_of_birth', date_of_birth));
						dispatch(change('CompanyJobDetailByCode', 'nationality', nationality));
						dispatch(change('CompanyJobDetailByCode', 'linkedin_url', linkedin_url));
						dispatch(change('CompanyJobDetailByCode', 'employment_history', formattedEmploymentHistory));
						dispatch(change('CompanyJobDetailByCode', 'education_background', formattedEducationBackground));
						// Keep skills as arrays since RenderTagsInput component can handle arrays directly
						dispatch(change('CompanyJobDetailByCode', 'soft_skills', soft_skills));
						dispatch(change('CompanyJobDetailByCode', 'hard_skills', hard_skills));
						dispatch(change('CompanyJobDetailByCode', 'languages', languages));
						dispatch(change('CompanyJobDetailByCode', 'certifications', certifications));
						dispatch(change('CompanyJobDetailByCode', 'key_achievements', formattedKeyAchievements));
						dispatch(change('CompanyJobDetailByCode', 'cv_raw_content', content))

						// Dispatch form field updates
						dispatch(change('CompanyTalentPoolByCode', 'fullname', fullname));
						dispatch(change('CompanyTalentPoolByCode', 'preferred_name', preferred_name));
						dispatch(change('CompanyTalentPoolByCode', 'email', email));
						dispatch(change('CompanyTalentPoolByCode', 'email2', email));
						dispatch(change('CompanyTalentPoolByCode', 'phone', phone));
						dispatch(change('CompanyTalentPoolByCode', 'address', address));
						dispatch(change('CompanyTalentPoolByCode', 'location', location));
						dispatch(change('CompanyTalentPoolByCode', 'date_of_birth', date_of_birth));
						dispatch(change('CompanyTalentPoolByCode', 'nationality', nationality));
						dispatch(change('CompanyTalentPoolByCode', 'linkedin_url', linkedin_url));
						dispatch(change('CompanyTalentPoolByCode', 'employment_history', formattedEmploymentHistory));
						dispatch(change('CompanyTalentPoolByCode', 'education_background', formattedEducationBackground));
						// Keep skills as arrays since RenderTagsInput component can handle arrays directly
						dispatch(change('CompanyTalentPoolByCode', 'soft_skills', soft_skills));
						dispatch(change('CompanyTalentPoolByCode', 'hard_skills', hard_skills));
						dispatch(change('CompanyTalentPoolByCode', 'languages', languages));
						dispatch(change('CompanyTalentPoolByCode', 'certifications', certifications));
						dispatch(change('CompanyTalentPoolByCode', 'key_achievements', formattedKeyAchievements));
						dispatch(change('CompanyTalentPoolByCode', 'cv_raw_content', content))
					} else {
						const { message } = content.response
						if (message) {
							const errMessage = translations['LABEL_CV_UNRESOLVED']
							const status = "failed"
							docAttachmentUpdated[curr_index]['errorMessage'] = errMessage
							docAttachmentUpdated[curr_index]['status'] = status
						}

						dispatch(docAttachmentSuccess(docAttachmentUpdated))
						dispatch(change('CompanyJobDetailByCode', 'cv_raw_content', content))
						return;
					}
				}

				docAttachmentUpdated[curr_index]['progressFile'] = docAttachmentUpdated[curr_index]['sizeFile']
				docAttachmentUpdated[curr_index]['progressUnit'] = docAttachmentUpdated[curr_index]['sizeUnit']
				docAttachmentUpdated[curr_index]['progress'] = 100
				docAttachmentUpdated[curr_index]['status'] = 'finish'
				docAttachmentUpdated[curr_index]['filepath'] = filepath
				dispatch(docAttachmentSuccess(docAttachmentUpdated))

				setTimeout(() => {
					docAttachmentUpdated = getState().documentAttachment.get('file_attachment').toJS()
					if (docAttachmentUpdated[curr_index]) {
						docAttachmentUpdated[curr_index]['showBarProgress'] = 0
					}
					dispatch(docAttachmentSuccess(docAttachmentUpdated))
				}, 3000);
			})
			.catch((error) => {
				console.log(error, 'error')
				if (error == 'canceled') {
					console.log('Request canceled', error.message)
				} else {
					let docAttachmentUpdated = getState().documentAttachment.get('file_attachment').toJS()

					docAttachmentUpdated[curr_index]['status'] = 'failed'
					dispatch(docAttachmentSuccess(docAttachmentUpdated))
				}
			})
	}
}


export function retrieveCVtoParsed(cvUrl) {
	return (dispatch, getState) => {

		const end_point = `https://cv.astrnt.co/api/parse`;
		const formData = new FormData();
		formData.append('file_url', cvUrl)
		return axios({
			url: end_point,
			method: "post",
			timeout: 200000,
			data: formData,
		})
			.then((response) => {
				const { data } = response.data
				const { profile } = data

				dispatch(change('CompanyJobDetailByCode', 'fullname', profile.name));
				dispatch(change('CompanyJobDetailByCode', 'preferred_name', profile.email));
				dispatch(change('CompanyJobDetailByCode', 'email', profile.email));
				dispatch(change('CompanyJobDetailByCode', 'phone', profile.phone));

			})
	}
}